var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment } from "react";
import { Form, Button } from "@atlassiansox/microscopekit";
import { ButtonGroup } from "@atlaskit/button";
import { DynamicFormField } from "../DynamicFormField";
export function DynamicForm(_a) {
    var fields = _a.fields, onSubmit = _a.onSubmit, onCancel = _a.onCancel, _b = _a.submitButtonText, submitButtonText = _b === void 0 ? "Submit" : _b, _c = _a.cancelButtonText, cancelButtonText = _c === void 0 ? "Cancel" : _c;
    return (React.createElement(Form, { onSubmit: onSubmit },
        fields.map(function (field, i) { return (React.createElement(Fragment, { key: field.name },
            i !== 0 && React.createElement("br", null),
            React.createElement(DynamicFormField, __assign({}, field)))); }),
        React.createElement("br", null),
        React.createElement("div", null,
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { onClick: onCancel }, cancelButtonText),
                React.createElement(Button, { appearance: "primary", type: "submit" }, submitButtonText)))));
}
